import React, { useContext } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Slide,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { DataContext } from "../../context/DataContext";
import { getTokens } from "../../theme";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Estructura y medidas calcadas del handoff: bloque modal de
// "Reportes CrediApp.dc.html" (panel radio 18, cabecera 20x24 con borde
// inferior, titulo Poppins 17, boton cerrar 36x36 radio 10, cuerpo 24).
// SmallModal y MediumModal solo se diferencian en el ancho.
const BaseModal = ({
  titulo,
  subtitulo,
  isVisible,
  setVisible,
  maxWidth,
  fullWidth,
  children,
}) => {
  const { isDarkMode } = useContext(DataContext);
  const t = getTokens(isDarkMode);

  return (
    <Dialog
      open={isVisible}
      onClose={() => setVisible(false)}
      TransitionComponent={Transition}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      BackdropProps={{ sx: { backgroundColor: "rgba(8,12,24,.55)" } }}
      PaperProps={{
        sx: {
          borderRadius: "18px",
          border: `1px solid ${t.line}`,
          boxShadow: "0 30px 60px -20px rgba(0,0,0,.5)",
          backgroundImage: "none",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          padding: "20px 24px",
          borderBottom: `1px solid ${t.line}`,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 600,
              fontSize: 17,
              color: "text.primary",
              lineHeight: 1.2,
            }}
          >
            {titulo}
          </Typography>
          {subtitulo ? (
            <Typography
              sx={{ fontSize: 12.5, color: "text.disabled", marginTop: "3px" }}
            >
              {subtitulo}
            </Typography>
          ) : null}
        </Box>

        <IconButton
          onClick={() => setVisible(false)}
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            backgroundColor: t.field,
            border: `1px solid ${t.fieldLine}`,
            color: "text.secondary",
            flexShrink: 0,
          }}
        >
          <CloseRoundedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>

      <DialogContent sx={{ padding: "24px" }}>{children}</DialogContent>
    </Dialog>
  );
};

export default BaseModal;
